import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    root: {},

    DetailsContainer: {
        minWidth: "100%",
        padding: 0
    }
}));
